"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Video;

var _react = _interopRequireDefault(require("react"));

var S = _interopRequireWildcard(require("./styled"));

function Video(_ref) {
  var src = _ref.src,
      poster = _ref.poster,
      _ref$controls = _ref.controls,
      controls = _ref$controls === void 0 ? true : _ref$controls,
      _ref$preload = _ref.preload,
      preload = _ref$preload === void 0 ? 'none' : _ref$preload;
  return /*#__PURE__*/_react["default"].createElement(S.Video, {
    src: src,
    poster: poster,
    controls: controls,
    preload: preload
  });
}